import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ActKc2CorrectionUpdateInput, UerUpdateActKc2CorrectionMutation } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateActKC2CorrectionGql } from '../../workOrderQueries';

interface IUseUerUpdateActKC2Correction {
    onSuccess: () => void;
}

const requestId = 'uerUpdateActKC2Correction';

export const useUerUpdateActKC2Correction = (props: IUseUerUpdateActKC2Correction) => {
    const dispatch = useDispatch();
    const { onSuccess } = props;

    const [uerUpdateActKC2CorrectionReset] = useResetStoreData({
        requestId,
    });

    const onSuccessLocal = useCallback(() => {
        uerUpdateActKC2CorrectionReset(undefined);
        onSuccess();
    }, [onSuccess, uerUpdateActKC2CorrectionReset]);

    const [, uerUpdateActKC2CorrectionStatus, , uerUpdateActKC2CorrectionRequest] =
        useRequest<UerUpdateActKc2CorrectionMutation>({
            requestId,
            query: uerUpdateActKC2CorrectionGql,
            withEffect: false,
            dependenciesUpdater: onSuccessLocal,
        });

    const uerUpdateActKC2CorrectionMakeRequest = useCallback(
        (input: ActKc2CorrectionUpdateInput) => {
            dispatch(uerUpdateActKC2CorrectionRequest({ input }));
        },
        [dispatch, uerUpdateActKC2CorrectionRequest],
    );

    return {
        uerUpdateActKC2CorrectionMakeRequest,
        uerUpdateActKC2CorrectionStatus,
    };
};
